export default {
  'followTable.columns.index': '序号',
  'followTable.columns.avatar': '头像',
  'followTable.columns.id': 'ID',
  'followTable.columns.nickname': '昵称',
  'followTable.columns.mobile': '手机号',
  'followTable.columns.comsume_status': '消费状态',
  'followTable.columns.last_report_time': '最后报备时间',
  'followTable.columns.next_contact_time': '下次回访时间',
  'followTable.columns.register_time': '注册时间',
  'followTable.columns.master_nickname': '归属人',
  'followTable.columns.master_mobile': '归属人手机号',
  'followTable.columns.master_group': '归属团队',
  'followUpTable.columns.follow_up_content': '回访内容',
  'followUpTable.columns.follow_up_time': '回访日期',
  'followUpTable.columns.staff_name': '回访人',
  'followUpTable.operation.create': '添加客户',
  'followTable.operations.write_record': '填写回访记录',
  'followTable.add_follow_up_plan': '添加回访计划',
  'followTable.add_follow_up_record': '添加回访记录',
};
